import { PageId } from "types";
import { fork } from "sagas/effects";
import { brieflyShowPageTitleInHero } from "sagas/hero";

export function* initializeImagePage(pageId: PageId) {
  yield fork(brieflyShowPageTitleInHero);
}
